import { Link, useParams } from "react-router-dom";
import arrowIcon from "../../images/arrow-icon.png";
import "./index.css";
import CardCarDetail from "../../components/cardCarDetail";
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import "react-phone-input-2/lib/style.css";
import FormikFromAirport from "./component/FormikFromAirport";
import FormikToAirport from "./component/FormikToAirport";
import ImportantMessage from "src/components/ImportantMessage";
import xIcon from "../../images/xIcon.png";
import { SurchargeData } from "../../components/CheckSurcharge";

const FormBooking = () => {
  const [isFromAirports, setIsFromAirports] = useState(true);
  const [isEditState, setEditState] = useState(false);
  const [editValue, setEditValue] = useState("");
  const [surchargeStartTime, setSurchargeStartTime] = useState("");
  const [surchargeEndTime, setSurchargeEndTime] = useState("");

  const params = useParams();

  /**
   * If the localStorage item "edit-form" is not null, set the edit state to true, set the
   * isFromAirports state to true if the type is "fromairport" and false if not, and set the editValue
   * state to the parsed JSON of the localStorage item "form-value" or an empty string
   */
  function checkEditState() {
    if (localStorage.getItem("edit-form") !== null) {
      let editValue: any = "";
      try {
        editValue = JSON.parse(localStorage.getItem("edit-form") || "");
      } catch (error) {
        console.log(error);
      }
      setEditState(true);
      setIsFromAirports(params.type === "fromairport" ? true : false);
      setEditValue(editValue);
    }
  }

  const setSurchargeTime = async () => {
    let surChargeData = await SurchargeData();
    surChargeData.data.forEach((item: any) => {
      if (item.key === "service_type_surcharge_start_time") {
        setSurchargeStartTime(item.value);
      } else if (item.key === "service_type_surcharge_end_time") {
        setSurchargeEndTime(item.value);
      }
    });
  };

  useEffect(() => {
    checkEditState();
    setSurchargeTime();
  }, []);

  return (
    <div className="flex flex-col justify-center items-center">
      <div className=" bg-white drop-shadow-xl lg:mt-[20px] mt-0 lg:mb-10 lg:px-[100px] py-[20px] space-y-3 lg:py-[40px] px-[20px] lg:rounded-xl">
        {/* TITLE */}
        <div className="absolute lg:right-10 right-5 ">
          <Link to={"/"} onClick={() => localStorage.clear()}>
            <div className="flex justify-end">
              <img src={xIcon} className="w-[14px]"></img>
            </div>
          </Link>
        </div>

        <div className="flex justify-center">
          <div className="flex flex-wrap w-full items-center justify-evenly space-y-3">
            <div className="flex flex-col">
              <div
                className="formTextContainer title lg:text-[20px] text-[20px]"
                style={{ marginBottom: "8px" }}
              >
                <div>Changi International Airport </div>
                <img
                  src={arrowIcon}
                  style={{ margin: "0px 20px", width: "30px", height: "27px" }}
                ></img>
                <a>City Transfer</a>
              </div>
              <div
                className="lg:text-[20px] text-[18px]"
                style={{ fontWeight: "400" }}
              >
                When and where are you heading :
              </div>
            </div>
            <div className=" noSelect cursor-pointer flex text-[12px] mb-5 lg:mb-0 md:w-fit w-full justify-center lg:space-x-10 space-x-7 md:space-y-0 md:space-x-10 md:mb-7 xl:space-y-0 ">
              <div
                onClick={() => {
                  setIsFromAirports(true);
                }}
                className="formButton px-[45px]  border-[3px] transition-all duration-150  ease-in-out"
                style={{
                  borderColor: isFromAirports ? "#384285" : "#fff",
                  borderStyle: "solid",
                }}
              >
                <div className="md:text-sm text-[13px] whitespace-nowrap">
                  ARRIVAL
                </div>
              </div>
              <div
                onClick={() => {
                  setIsFromAirports(false);
                }}
                className="formButton px-[35px] border-[3px] transition-all duration-150  ease-in-out"
                style={{
                  borderColor: isFromAirports ? "#fff" : "#384285",
                  borderStyle: "solid",
                }}
              >
                <div className="md:text-sm text-[13px] whitespace-nowrap">
                  DEPARTURE
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="formContainer">
          <div className="fieldContainer">
            <div>
              {isFromAirports ? (
                <FormikFromAirport
                  vehicleId={Number(params.carId)}
                  editValue={isEditState ? editValue : null}
                  editState={isEditState}
                />
              ) : (
                <FormikToAirport
                  vehicleId={Number(params.carId)}
                  editValue={isEditState ? editValue : null}
                  editState={isEditState}
                />
              )}
            </div>
          </div>
          {/* RightSide Tamplate*/}
          <div className="flex flex-wrap justify-center items-center lg:justify-evenly space-x-0">
            <div>
              <CardCarDetail carId={Number(params.carId)} button={false} />
            </div>

            <div className="flex flex-col">
              <div
                className="space-y-5"
                style={{ fontSize: "15px", margin: "30px 0px" }}
              >
                <div className="font-semibold py-3 bg-gray-200 rounded-lg flex lg:justify-start justify-center">
                  <div className="lg:ml-8">Important</div>
                </div>
                <div className="px-5">
                  {!isFromAirports &&
                    (Number(params.carId) === 2 ||
                      Number(params.carId) === 4) && (
                      <li>
                        {`Midnight surcharge applies for trip to airport between 
                      ${surchargeStartTime}hrs - ${surchargeEndTime}hrs.`}
                      </li>
                    )}

                  <ImportantMessage />
                </div>
                <div className="px-6">
                  <a>
                    By submitting this form, you agree to our{" "}
                    <Link to="/TermAndConditions" className="text-regal-blue">
                      Terms & Conditions
                    </Link>
                  </a>
                </div>
              </div>
              <div className="flex justify-center">
                <Button
                  variant="contained"
                  type={"submit"}
                  form="formikForm"
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    width: "300px",
                    height: "50px",
                    borderRadius: "10px",
                    backgroundColor: "#384285",
                  }}
                >
                  Submit Booking
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormBooking;
